// extracted by mini-css-extract-plugin
module.exports = {"NavigationBar":"NavigationBar_NavigationBar__3VJnC","NavigationLinks":"NavigationBar_NavigationLinks__RcP4l"};